import {reduce, reversed} from './array';

const
    complement = fn => (...args) => !fn(...args),

    compose = (...fns) => {
        const [first, ...rest] = reversed(fns);

        return (
            (...args) => (
                reduce(
                    rest,
                    (arg, fn) => fn(arg),
                    first ? first(...args) : args[0])));
    },

    identity = value => value,

    noop = () => {},

    once = (
        (uninitialized => (
            fn => {
                let value = uninitialized;

                return () => {
                    if (value === uninitialized) {
                        value = fn();
                        fn = null;
                    }
                    return value;
                };
            }))({})),

    times = (count, fn) => {
        for (let i = 0; i < count; i += 1) {
            fn(i, count);
        }
    };

export {
    complement,
    compose,
    identity,
    noop,
    once,
    times
};
